export default __webpack_public_path__ + "static/media/warningjob.34e4907c.svg";